import React, {useEffect, useState} from 'react'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import {useHistory, useLocation, useParams} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {QueryData} from '../../../../reusable-components/tables/DynamicTableTypes'
import {RootState} from '../../../../../setup'
import axios from 'axios'
import dayjs from 'dayjs'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
import {
  THERAPY_ENTRIES_COLUMNS,
  THERAPY_ENTRIES_COLUMNS_DATA_MAPPING,
  THERAPY_ENTRIES_SORTING_COLUMNS,
} from '../../../Notes/Speech_therapy/SPEECH_THERAPY_TABLE_CONSTANTS'
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

const DeletedSpeechTherapyNotes = () => {
  const location = useLocation()
  const [filteredData, setFilteredData] = useState([])
  const [isFetchingData, setIsFetchingData] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const queryParams = new URLSearchParams(location.search)
  const noteType = queryParams.get('noteType')
  const timeZone = useSelector(selectTimeZone)
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })
  const params: {id: string} = useParams()
  const history = useHistory()
  
  useEffect(() => {
    const fetchData = async (page: number, pageSize: number, sortBy: string, sortDir: string) => {
      setIsFetchingData(true)
      const responseForNote = await axios.get(
        `/speechTherapyEntry/getByClient/${params.id}?noteType=${noteType}&isDeleted=true`,
        {
          params: {
            page: page,
            pageSize: pageSize,
            sortBy: sortBy,
            sortDir: sortDir,
            searchTerm: queryData.searchTerm,
          },
        }
      )
      const {data: noteData, currentPage, totalCounts} = responseForNote?.data
      const updatedNoteData = noteData.map((item) => ({
        ...item,
        startDate: item?.startDate
          ? dayjs.utc(item.startDate).tz(timeZone).format('MM-DD-YYYY')
          : 'No details provided',
        endDate: item?.endDate
          ? dayjs.utc(item.endDate).tz(timeZone).format('MM-DD-YYYY')
          : 'No details provided',
      }))
      setFilteredData(updatedNoteData)
      setQueryData((prevState) => {
        return {
          ...prevState,
          currentPage,
          totalCounts,
        }
      })
      setIsFetchingData(false)
    }
    fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir)
  }, [
    queryData.pageNumber,
    queryData.pageSize,
    queryData.sortBy,
    queryData.sortDir,
    queryData.searchTerm,
  ])
  const onUpdate = (row) => {
    history.push(`/deleted-notes/speech-therapy-notes/entry/${row._id}?noteType=${row.noteType}`)
  }
  return (
    <div className='card'>
      <div className='card-body'>
        <TableTitle title='Deleted Speech Therapy Notes'></TableTitle>
        <TableWrapper
          searchField={
            <TableSearchBar
              label='Search'
              variant='outlined'
              size='small'
              value={searchTerm}
              setQueryData={setQueryData}
              setSearchTerm={setSearchTerm}
              margin='normal'
              inputAdornmentPosition='start'
            ></TableSearchBar>
          }
          tableButtons={[]}
          dynamicTable={
            <DynamicTable
              queryData={queryData}
              setQueryData={setQueryData}
              htmlColumns={[]}
              canUpdate={true}
              onUpdate={onUpdate}
              columns={THERAPY_ENTRIES_COLUMNS}
              sortingColumns={THERAPY_ENTRIES_SORTING_COLUMNS}
              data={filteredData}
              columnDataMapping={THERAPY_ENTRIES_COLUMNS_DATA_MAPPING}
              tableLoader={isFetchingData}
            />
          }
        />
      </div>
    </div>
  )
}

export default DeletedSpeechTherapyNotes
